import {Component, OnInit} from '@angular/core';
import {BlockAbstractComponent} from '@gallaghercp/core-frontend';

@Component({
    selector: 'core-one-page-callout',
    templateUrl: './wallet-pass-download.component.html',
    styleUrls: ['./wallet-pass-download.component.scss'],
    standalone: false
})

export class WalletPassDownloadComponent extends BlockAbstractComponent implements OnInit {
    public isIOS: boolean = false;
    public isAndroid: boolean = false;
    public isMac: boolean = false;

    override ngOnInit(): void {
        this.detectPlatform();
    }

    private detectPlatform(): void {
        const userAgent = navigator.userAgent || navigator.vendor;

        this.isIOS = /iPad|iPhone|iPod/.test(userAgent);
        this.isAndroid = /android/i.test(userAgent);
        this.isMac = /Macintosh|MacIntel|MacPPC|Mac68K/.test(navigator.platform);

        console.log('Platform Detection:', {
            isIOS: this.isIOS,
            isAndroid: this.isAndroid,
            isMac: this.isMac,
        });
    }


}
